// CustomToast.jsx
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CustomToast = ({
  open,
  handleClose,
  message,
  severity,
  position,
  offset,
  index,
  toastsLength,
}) => {
  const { vertical, horizontal } = position;
  const isDayRateWarning =
    severity === "dayRateWarning" || severity === "dayRateWarining";

  return (
    <Snackbar
      className="toaster"
      // className={`toaster ${message?.length > 60 ? "long-toast" : ""}`}
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      autoHideDuration={message?.length > 60 ? 7000 : 4000}
      // autoHideDuration={600000}
      onClose={handleClose}
      style={{
        top:
          isDayRateWarning ||
          severity === "reopenBilling" ||
          severity === "reopenInvoice" ||
          severity === "emailSent"
            ? `calc(${offset}px + 4rem)`
            : `calc(${offset}px + 8px)`,
        position: "fixed",
        ...(isDayRateWarning
          ? { right: "8px", bottom: `${index * 80 + 16}px` }
          : { right: "8px" }),
      }} // Adjust the positioning
      // key={vertical + horizontal}
      key={`toast-${Date.now()}-${vertical}-${horizontal}`}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        iconMapping={{
          success: <CheckCircleIcon fontSize="inherit" />,
          error: <ErrorIcon fontSize="inherit" />,
          groupError: <ErrorIcon fontSize="inherit" />,
          warning: (
            <ErrorIcon fontSize="inherit" style={{ color: "#007FFF" }} />
          ),
          reopenBilling: (
            <ErrorIcon fontSize="inherit" style={{ color: "#007FFF" }} />
          ),
          dayRateWarning: (
            <ErrorIcon fontSize="inherit" style={{ color: "#007FFF" }} />
          ),
          dayRateWarining: (
            <ErrorIcon fontSize="inherit" style={{ color: "#007FFF" }} />
          ),
        }}
        sx={{
          width: "100%",
          maxWidth: "600px",
          borderBottom: `4px solid ${
            severity === "success"
              ? "#4caf50"
              : severity === "error" || severity === "groupError"
              ? "#f44336"
              : "#007FFF"
          }`,
          backgroundColor: "#fff",
          color: "#000",
          paddingBottom: "15px",
          filter: "drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.25))",
          // mb: 1,
          marginBottom: "-30px",
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <span className="toast-title">
          {severity === "success"
            ? "Success"
            : severity === "error"
            ? "Error"
            : severity === "groupError"
            ? "Error"
            : severity === "reopenBilling"
            ? "Billing Statement Read Only"
            : severity === "reopenInvoice"
            ? "Invoice is Read Only"
            : severity === "emailSent"
            ? "Email Confirmation Sent"
            : "Note"}
        </span>
        <br />

        {severity == "groupError" ? (
          <ul style={{ marginTop: "5px", marginBottom: "0px" }}>
            {message.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        ) : (
          <span className="toast-text">{message}</span>
        )}
      </Alert>
    </Snackbar>
  );
};

export default CustomToast;
